/**
 * Feature Flags Configuration
 * 
 * Set flags to `true` to enable the feature, `false` to disable.
 */
export const featureFlags = {
  // --- Rendering Flags --- 
  ENABLE_PRESENCE_INDICATOR: true, // Controls rendering of the PresenceIndicator in the Navbar
  ENABLE_THEME_TOGGLE: true,       // Controls rendering of the ThemeToggle button
  ENABLE_USER_PROFILE_DIALOG: true, // Controls rendering of the UserProfileDialog
  ENABLE_DEBUG_PANEL: true,        // Controls rendering of the ConsolidatedDebugPanel
  ENABLE_COLLABORATIVE_CURSORS: true, // Controls rendering of collaborative cursors
  
  // --- Logic Flags --- 
  ENABLE_PROFILE_CHECKING: false,  // TEMPORARILY DISABLED - Controls the profile completeness check in App.tsx
  ENABLE_NAVBAR_PROFILE_EFFECT: true, // Controls the useEffect in InstantNavbar that sets currentUserProfile
  ENABLE_GOOGLE_AUTH_PROFILE_UPDATE: false, // TEMPORARILY DISABLED - Controls the Google Auth profile update logic in App.tsx
}; 